$(document).ready(function(){
 
  // $('.review-slider-outer').flickity({
  // // options
  //   //groupCells:true, 
  //   prevNextButtons: false,
  //   //wrapAround: true,
  //   contain: true,
  //   pageDots: false,
  //   //initialIndex: 1,
  //   //accessibility: true, //true by default
  // //freeScroll: true,
  // });

  
$('.style-1 .review-slider-outer').slick({
 // autoplay: true,
  dots: true,
  arrows: true, 
  prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="20" height="36" viewBox="0 0 20 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.75 2.5L2.25 18L17.75 33.5" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="20" height="36" viewBox="0 0 20 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.25 2.5L17.75 18L2.25 33.5" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]  
});


////////////
  
$('.style-2 .review-slider-outer').slick({
 // autoplay: true,
  dots: true,
  arrows: false, 
  prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="20" height="36" viewBox="0 0 20 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.75 2.5L2.25 18L17.75 33.5" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="20" height="36" viewBox="0 0 20 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.25 2.5L17.75 18L2.25 33.5" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  infinite: true,
  centerMode: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]  
});  
});